const Logo = require("../assets/images2/Logo_1.png")
const RedLogo = require("../assets/images2/m.png")
const Verify = require("../assets/images2/verified.png")
const remove  = require("../assets/images2/remove.png")
const Sidebtndots = require('../assets/images2/Sidebtndots.png')
const win  = require("../assets/images2/win.png")
const writing = require("../assets/images2/writing.png")
const quiz = require("../assets/images2/quizz.png")
const support = require("../assets/images2/support.png")
const google = require("../assets/images2/google.png");
const apple = require("../assets/images2/apple.png")
const medal = require("../assets/images2/medal.png")
const man = require("../assets/images2/man.png")
const women = require("../assets/images2/woman.png")
const start = require("../assets/images2/start.png")
const students = require("../assets/images2/students.png")
const winners = require("../assets/images2/winners.png")
const quizlist = require("../assets/images2/quizlist.png")
const essaylist = require("../assets/images2/essaylist.png")
const open = require("../assets/images2/open.png");
const open_done  = require("../assets/images2/open_done.png")
const expired =  require("../assets/images2/expired.png");
const check = require("../assets/images2/check.png")
const commingsoon = require("../assets/images2/CS.png")
const add = require("../assets/images2/add.png");
const submit = require("../assets/images2/submit.png");
const logout = require("../assets/images2/logout.png");
const exit = require("../assets/images2/exit.png")
const RedIcon = require("../assets/images2/icon.png");
const appstore = require("../assets/images2/appstore.png")
const playstore  = require("../assets/images2/playstore.png")
const filterdata = require('../assets/images2/filterdata.png')

export {
    Logo,
    RedLogo,
    Verify,
    remove,
    Sidebtndots,
    win,
    writing,
    quiz,
    support,
    google,
    apple,
    medal,
    man,
    women,
    start,
    students,
    winners,
    quizlist,
    essaylist,
    open,
    open_done,
    expired,
    check,
    commingsoon,
    add,
    submit,
    logout,
    exit,
    RedIcon,
    appstore,
    playstore,
    filterdata

}